var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatbotTwoWayOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.053,
    height: 18,
    viewBox: "0 0 17.053 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1692",
    "data-name": "Group 1692",
    transform: "translate(-23880.572 -39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_744",
    "data-name": "Rectangle 744",
    transform: "translate(23880.572 39)",
    fill: "#d0d0d0",
    stroke: "#d0d0d0",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 11,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 11,
    height: 10,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_745",
    "data-name": "Rectangle 745",
    transform: "translate(23886.625 46)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 10,
    height: 10,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrows-alt-h",
    "data-name": "Icon awesome-arrows-alt-h",
    d: "M10.467,1.052l.05,1.268L3.769,2.057,3.719.79A.7.7,0,0,0,2.567.279L.278,2.554a.659.659,0,0,0,.037.934L2.789,5.949A.634.634,0,0,0,3.9,5.526l-.05-1.268,6.749.263.05,1.268A.7.7,0,0,0,11.8,6.3l2.289-2.276a.659.659,0,0,0-.037-.934L11.583.63a.634.634,0,0,0-1.115.423Z",
    transform: "translate(23886.467 39.607) rotate(47)",
    fill: "#000000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotTwoWayOn);
export default __webpack_public_path__ + "static/media/chatbotTwoWayOn.a5f20d464901f9e868935acde9b7918f.svg";
export { ForwardRef as ReactComponent };